export const relationshipTypeOptions = [
  "Enemy",
  "Enemy-Cluing",
  "Enemy-Parallel",
  "Enemy-Identical",
  "Enemy-MIC",
  "Enemy-Revised",
  "Enemy-Reuse",
  "Predecessor",
  "Successor",
  "Parent",
  "Child",
  "Sibling",
  "Parent-Accessible",
  "Child-Accessible",
  "Sibling-Accessible",
  "Parent-Language",
  "Child-Language",
  "Sibling-TEI Item",
  "Sibling-MC Item",
  "Overlap",
  "Parent-MIC",
  "Parent-Reporting",
  "Child-Reporting",
];

export const reciprocalRelationshipTypes = {
  Enemy: "Enemy",
  "Enemy-Cluing": "Enemy-Cluing",
  "Enemy-Parallel": "Enemy-Parallel",
  "Enemy-Identical": "Enemy-Identical",
  "Enemy-MIC": "Enemy-MIC",
  "Enemy-Revised": "Enemy-Revised",
  "Enemy-Reuse": "Enemy-Reuse",
  Predecessor: "Successor",
  Successor: "Predecessor",
  Parent: "Child",
  Child: "Parent",
  Sibling: "Sibling",
  "Parent-Accessible": "Child-Accessible",
  "Child-Accessible": "Parent-Accessible",
  "Sibling-Accessible": "Sibling-Accessible",
  "Parent-Language": "Child-Language",
  "Child-Language": "Parent-Language",
  "Sibling-TEI Item": "Sibling-MC Item",
  "Sibling-MC Item": "Sibling-TEI Item",
  Overlap: "Overlap",
  "Parent-MIC": null,
  "Parent-Reporting": "Child-Reporting",
  "Child-Reporting": "Parent-Reporting",
};

export const dataSourceOptions = ["CDE", "TDSYS", "VITA", "Other"];

export const metadataCardTabs = (externalReview) => {
  if (externalReview)
    return {
      item: [
        {
          label: "General",
          controls: ["contentArea", "gradeLevel", "difficulty"],
        },
      ],
      passage: [],
    };
  return {
    item: [
      {
        label: "General",
        controls: [
          "description",
          "universalDesign",
          "contentArea",
          "format",
          "type",
          "points",
          "gradeLevel",
          "gradeSpanStart",
          "gradeSpanEnd",
          "contentSpecialist",
          "itemWriter",
          "language",
          "snapToHighlight",
          "aiContent",
          "createdByUser",
          "createdDateTime",
          "lastModifiedByUser",
          "lastModifiedDateTime",
        ],
      },
      {
        label: "Text Eval",
        controls: [
          "wordCount",
          "cbtCharacterCount",
          "pbtCharacterCount",
          "textComplexity",
          "readabilityIndex",
        ],
      },
      {
        label: "Standards",
      },
      {
        label: "Lifecycle",
        controls: [
          "cdeID",
          "developmentState",
          "resource",
          "scoringMethod",
          "partialScore",
          "passthrough",
          "externalID",
          "foreignID",
          "importID",
          "useScreenReader",
          "useTextToSpeech",
          "contentLicensed",
          "elementStatus",
          "release",
          "restriction",
          "unavailability",
          "itemBasedOnPassage",
          "lockFoilOrder",
          "itemModel",
          "pretestGroup",
          "copyrightDate",
          "copyrightCertificate",
          "firstBankedDateTime",
          "lastBankedDateTime",
        ],
      },
      {
        label: "Classifications",
        controls: [
          "difficulty",
          "depthOfKnowledge",
          "secondaryDOK",
          "tertiaryDOK",
          "cognitiveCode",
          "mathTaxonomyCode",
          "mathTaxonomyList",
          "modeling",
          "passageAsAWhole",
          "uct",
          "jeLevel",
          "graphicComplexity",
          "generality",
          "primaryContentCode",
          "secondaryContentCode",
          "careerCluster",
          "skillSubdomain",
          "application",
          "itemLevel",
          "idealPretestLocation",
          "subProgram",
        ],
      },
      {
        label: "Relationships",
        controls: [
          {
            label: "Data Source",
            name: "source",
            options: dataSourceOptions.map((option) => ({
              label: option,
              value: option,
            })),
            rules: {
              required: true,
            },
            type: "select",
          },
          {
            name: "program",
            type: "select",
            label: "Program",
            options: [],
            rules: {
              required: true,
            },
          },
          {
            fullWidth: true,
            label: "Item Name",
            name: "name",
            rules: {
              required: true,
              maxLength: 50,
            },
            multiline: false,
            type: "text",
          },
          {
            label: "Relationship Type",
            name: "type",
            options: relationshipTypeOptions.map((option) => ({
              label: option,
              value: option,
            })),
            rules: {
              required: true,
            },
            type: "select",
          },
        ],
      },
      {
        label: "References",
        controls: [
          {
            name: "referenceTitle",
            type: "text",
            label: "Reference Title",
            rules: {
              maxLength: 150,
              required: true,
            },
          },
          {
            name: "workTitle",
            type: "text",
            label: "Work Title",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "author",
            type: "text",
            label: "Author",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "publicationInformation",
            type: "text",
            label: "Publication Information",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "page",
            type: "text",
            label: "Page",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "copyrightYear",
            type: "integer",
            label: "Copyright Year",
            multiline: false,
            rules: {
              maxLength: 4,
            },
          },
          {
            name: "rightsHolder",
            type: "text",
            label: "Rights Holder",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "publisher",
            type: "text",
            label: "Publisher",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "sourceURL",
            type: "text",
            label: "Source URL",
            multiline: false,
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "ISBN",
            type: "text",
            label: "ISBN",
            multiline: false,
            rules: {
              maxLength: 20,
            },
          },
          {
            name: "wordCount",
            type: "integer",
            label: "Word Count",
            multiline: false,
            rules: {
              maxLength: 5,
            },
          },
          {
            name: "publicDomain",
            type: "switch",
            label: "Public Domain",
            rules: "",
          },
          {
            name: "commissioned",
            type: "switch",
            label: "Commissioned",
            rules: "",
          },
          {
            name: "notes",
            type: "text",
            label: "Notes",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "citation",
            type: "editor",
            label: "Citation",
            rules: "",
          },
        ],
      },
      {
        label: "Diversity",
        controls: [
          "ethnicity",
          "subEthnicity",
          "gender",
          "income",
          "region",
          "subRegion",
          "religion",
          "urbanicity",
          "genderRole1",
          "genderRole2",
          "genderRole3",
          "groupRole1",
          "groupRole2",
          "groupRole3",
        ],
      },
      {
        label: "Memo",
        controls: ["memo"],
      },
    ],
    passage: [
      {
        label: "General",
        controls: [
          "summary",
          "universalDesign",
          "contentArea",
          "language",
          "gradeLevel",
          "gradeSpanStart",
          "gradeSpanEnd",
          "contentSpecialist",
          "itemWriter",
          "aiContent",
          "createdByUser",
          "createdDateTime",
          "lastModifiedByUser",
          "lastModifiedDateTime",
        ],
      },
      {
        label: "Text Eval",
        controls: [
          "wordCount",
          "cbtCharacterCount",
          "pbtCharacterCount",
          "averageStandardWordCount",
          "fleschKincaid",
          "textComplexity",
          "readabilityIndex",
          "readingLevelNotes",
        ],
      },
      {
        label: "Standards",
      },
      {
        label: "Lifecycle",
        controls: [
          "cdeID",
          "developmentState",
          "resource",
          "elementStatus",
          "release",
          "restriction",
          "unavailability",
          "width",
          "externalID",
          "foreignID",
          "importID",
          "useScreenReader",
          "useTextToSpeech",
          "contentLicensed",
          "referenceDynamicValidation",
          "copyrightDate",
          "copyrightCertificate",
          "firstBankedDateTime",
          "lastBankedDateTime",
        ],
      },
      {
        label: "Classifications",
        controls: [
          "type",
          "subType",
          "secondaryType",
          "secondarySubType",
          "pointOfView",
          "presentationFormat",
          "topic",
          "crossCurriculum",
          "cognitiveCode",
          "application",
          "unitStrength",
          "primaryContentCode",
          "secondaryContentCode",
          "subProgram",
          "argumentativePassageSet",
          "pairedPassage",
          "shortPassageSet",
          "vqiPassageSet",
          "keywords",
          "ngss1",
          "ngss2",
          "ngss3",
          "predictedUnitDifficulty",
        ],
      },
      {
        label: "Relationships",
        controls: [
          {
            label: "Data Source",
            name: "source",
            options: dataSourceOptions.map((option) => ({
              label: option,
              value: option,
            })),
            rules: {
              required: true,
            },
            type: "select",
          },
          {
            name: "program",
            type: "select",
            label: "Program",
            options: [],
            rules: {
              required: true,
            },
          },
          {
            fullWidth: true,
            label: "Passage Name",
            name: "name",
            rules: {
              required: true,
              maxLength: 50,
            },
            multiline: false,
            type: "text",
          },
          {
            label: "Relationship Type",
            name: "type",
            options: relationshipTypeOptions
              .filter(
                (type) =>
                  ["Sibling-MC Item", "Sibling-TEI Item"].indexOf(type) === -1,
              )
              .map((option) => ({
                label: option,
                value: option,
              })),
            rules: {
              required: true,
            },
            type: "select",
          },
        ],
      },
      {
        label: "References",
        controls: [
          {
            name: "referenceTitle",
            type: "text",
            label: "Reference Title",
            rules: {
              maxLength: 150,
              required: true,
            },
          },
          {
            name: "workTitle",
            type: "text",
            label: "Work Title",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "author",
            type: "text",
            label: "Author",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "publicationInformation",
            type: "text",
            label: "Publication Information",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "page",
            type: "text",
            label: "Page",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "copyrightYear",
            type: "integer",
            label: "Copyright Year",
            multiline: false,
            rules: {
              maxLength: 4,
            },
          },
          {
            name: "rightsHolder",
            type: "text",
            label: "Rights Holder",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "publisher",
            type: "text",
            label: "Publisher",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "sourceURL",
            type: "text",
            label: "Source URL",
            multiline: false,
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "ISBN",
            type: "text",
            label: "ISBN",
            rules: {
              maxLength: 20,
            },
          },
          {
            name: "wordCount",
            type: "integer",
            label: "Word Count",
            multiline: false,
            rules: {
              maxLength: 5,
            },
          },
          {
            name: "publicDomain",
            type: "switch",
            label: "Public Domain",
            rules: "",
          },
          {
            name: "commissioned",
            type: "switch",
            label: "Commissioned",
            rules: "",
          },
          {
            name: "notes",
            type: "text",
            label: "Notes",
            rules: {
              maxLength: 150,
            },
          },
          {
            name: "citation",
            type: "editor",
            label: "Citation",
            rules: "",
          },
        ],
      },
      {
        label: "Diversity",
        controls: [
          "ethnicity",
          "subEthnicity",
          "gender",
          "income",
          "region",
          "subRegion",
          "religion",
          "urbanicity",
          "genderRole1",
          "genderRole2",
          "genderRole3",
          "groupRole1",
          "groupRole2",
          "groupRole3",
        ],
      },
    ],
  };
};
